import type { NavLinkProps } from '@/types';
import * as Styled from './MenuToggle.styled';

interface NavItemProps {
  link: NavLinkProps;
}

export const NavItem = ({
  link: { highlightColour, href, target, textContent },
}: NavItemProps) => {
  // Deliberately NO close handler. This component renders every link in the mobile menu — the
  // top-level list, the utility list, the featured lists and the submenu leaves — so wiring
  // closeMenu here slid the whole panel out on any link press, animating away under the user
  // while the browser was still navigating. Closing the panel is the X button's job alone
  // (MenuHeader), plus the dismiss affordances React Aria gives the dialog (Escape, outside
  // press). If you are reinstating a handler here, you are re-adding that bug.
  const linkProps = {
    href,
    ...(target ? { target, rel: 'noopener' } : {}),
  };

  return (
    <li>
      <Styled.NavLink {...linkProps} $highlightColour={highlightColour}>
        {textContent}
      </Styled.NavLink>
    </li>
  );
};
